/* eslint-disable no-param-reassign */
import openSaveSearchModal from './openSaveSearchModal';
import openLoginModal from '../login/openLoginModal';
import { setItem } from '../localStorage';

const doCreateSaveSearchModal = async ({
  closeModal,
  openModalAction,
  closeModalAction,
  createNewSaveSearchModal,
  createGenericAfterSpecificModal,
  createNewSaveSearchFeedbackModal,
  createFeedbackModal,
  isMobile,
  isSmallMobile,
  filtersProps,
  saveSearchProps,
  panelChooseBy,
}) => {
  await closeModalAction({ close: closeModal });
  setTimeout(() => {
    openSaveSearchModal({
      openModalAction,
      closeModalAction,
      createNewSaveSearchModal,
      createGenericAfterSpecificModal,
      createNewSaveSearchFeedbackModal,
      createFeedbackModal,
      isMobile,
      isSmallMobile,
      filtersProps,
      saveSearchProps,
      panelChooseBy,
    });
  }, 451);
};

const doCreateLoginModal = async ({
  openModalAction,
  closeModalAction,
  createLoginModal,
  getUser,
  getUserLoginPayload,
  showSynchingDialog,
  closeModal,
  doCreateSaveSearchModal: createSaveSearchModal,
  doCreateSaveSearchModalPayload,
  validBookmarkData,
  authBasePrefix,
}) => {
  await closeModalAction({ close: closeModal });
  setTimeout(() => {
    const postLoginAction = () => {
      closeModal();
      showSynchingDialog(async () => {
        validBookmarkData.saveSearchProps.user = getUser();
        createSaveSearchModal({
          closeModal,
          ...doCreateSaveSearchModalPayload,
          ...validBookmarkData,
        });
      });
    };

    const loginModalData = getUserLoginPayload({ postLoginAction });
    openLoginModal({
      openModalAction,
      closeModalAction,
      createLoginModal,
      loginModalData,
      authBasePrefix,
    });
  }, 301);
};

export default ({
  isMobile,
  openModalAction,
  closeModalAction,
  createProposeSaveSearchModal,
  createNewSaveSearchModal,
  createGenericAfterSpecificModal,
  createNewSaveSearchFeedbackModal,
  createFeedbackModal,
  proposeSaveSearchData,
  disableHistoryBackOnClose,
}) => {
  const {
    adData,
    searchData,
    createLoginModal,
    getUser,
    getUserLoginPayload,
    showSynchingDialog,
    publisher,
    isFromCallphone,
  } = proposeSaveSearchData;

  openModalAction(createProposeSaveSearchModal({
    isMobile,
    adData,
    searchData,
    publisher,
    doCreateLoginModal,
    doCreateLoginModalPayload: {
      openModalAction,
      closeModalAction,
      createLoginModal,
      getUser,
      getUserLoginPayload,
      showSynchingDialog,
    },
    doCreateSaveSearchModal,
    doCreateSaveSearchModalPayload: {
      openModalAction,
      closeModalAction,
      createNewSaveSearchModal,
      createGenericAfterSpecificModal,
      createNewSaveSearchFeedbackModal,
      createFeedbackModal,
    },
    disableHistoryBackOnClose,
    isFromCallphone,
  }));

  const ts = new Date().getTime();
  setItem('proposeSaveSearchTime', ts);
};
